import React from 'react';

import PropTypes from 'prop-types';

/**
 * Returns {span} containing a string of states
 * @param {array} states Expected array of states
 */
export const ShowStates = ({ states }) => {
    const displayStates = () => {
        const allStates = states.length === 51;
        if (allStates) {
            return 'All States';
        }

        return (
            states.map((state, i) => (
                <React.Fragment key={state.id}>
                    {state.abbreviation}{states.length - 1 === i ? '' : ', '}
                </React.Fragment>
            ))
        );
    };

    return (
        <div>
            {
                states && states.length !== 0
                && (
                    <span className="tooltip-header tooltip-states">
                        States:
                    </span>
                )
            }
            {
                states && states.length !== 0
                && (
                    <span className="tooltip-values tooltip-states">
                        {displayStates()}
                    </span>
                )
            }
        </div>
    );
};

ShowStates.propTypes = {
    states: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        abbreviation: PropTypes.string,
    })).isRequired,
};
